import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { FormControl, FormControlLabel } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Typography, RaiseColors } from "componentLibrary";
import { Checkbox } from "client/componentLibrary";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    wrapper: function wrapper(_ref) {
      var expandToFillContainerHeight = _ref.expandToFillContainerHeight;
      return _objectSpread({
        display: "flex",
        flexDirection: "column"
      }, expandToFillContainerHeight ? {
        flex: 1,
        minHeight: 0
      } : {
        height: "100%"
      });
    },
    formControl: function formControl(_ref2) {
      var expandToFillContainerHeight = _ref2.expandToFillContainerHeight;
      return _objectSpread({
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        gap: "8px"
      }, expandToFillContainerHeight ? {
        flex: 1,
        minHeight: 0
      } : {
        maxHeight: "400px"
      });
    }
  };
});
var checkboxStyles = makeStyles(function (theme) {
  return {
    checkbox: {
      border: "none",
      padding: "0px"
    },
    formControlLabel: {
      margin: "8px",
      width: "100%"
    },
    formControlLabelActionButtons: {
      margin: "8px",
      width: "100%",
      "& .MuiFormControlLabel-label": {
        width: "100%"
      }
    },
    labelContainer: {
      borderRadius: "8px",
      display: "flex",
      "&:hover": {
        backgroundColor: RaiseColors.grayscale200
      }
    }
  };
});
export var CheckBoxGroup = function CheckBoxGroup(_ref3) {
  var checkboxGroupElements = _ref3.checkboxGroupElements,
    filterName = _ref3.filterName,
    onChange = _ref3.onChange,
    _ref3$actionButtons = _ref3.actionButtons,
    actionButtons = _ref3$actionButtons === void 0 ? [] : _ref3$actionButtons,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled;
  var classes = checkboxStyles();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: checkboxGroupElements === null || checkboxGroupElements === void 0 ? void 0 : _mapInstanceProperty(checkboxGroupElements).call(checkboxGroupElements, function (element, index) {
      var isDisabled = element.isDisabled || disabled;
      return /*#__PURE__*/_jsx("div", {
        className: classes.labelContainer,
        children: /*#__PURE__*/_jsx(FormControlLabel, {
          control: /*#__PURE__*/_jsx(Checkbox, {
            name: filterName,
            fontSize: 20,
            value: element.id,
            checked: element.isChecked,
            disabled: isDisabled,
            onChange: onChange,
            classes: {
              root: classes.checkbox
            }
          }),
          label: actionButtons.length > 0 ? /*#__PURE__*/_jsxs("div", {
            style: {
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            },
            children: [typeof element.label === "string" ? /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph_small",
              weight: "medium",
              style: {
                marginLeft: "16px"
              },
              color: isDisabled ? RaiseColors.grayscale900 : RaiseColors.glacier2400,
              noWrap: true,
              children: element.label
            }) : /*#__PURE__*/_jsx("div", {
              style: {
                marginLeft: "16px"
              },
              children: element.label
            }), /*#__PURE__*/_jsx("div", {
              style: {
                display: "flex",
                gap: "8px"
              },
              children: actionButtons === null || actionButtons === void 0 ? void 0 : _mapInstanceProperty(actionButtons).call(actionButtons, function (ActionButton) {
                return ActionButton(element, index);
              })
            })]
          }) : typeof element.label === "string" ? /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_small",
            weight: "medium",
            style: {
              marginLeft: "16px"
            },
            color: isDisabled ? RaiseColors.grayscale900 : RaiseColors.glacier2400,
            noWrap: true,
            children: element.label
          }) : /*#__PURE__*/_jsx("div", {
            style: {
              marginLeft: "16px"
            },
            children: element.label
          }),
          classes: {
            root: actionButtons.length > 0 ? classes.formControlLabelActionButtons : classes.formControlLabel
          }
        })
      }, element.id);
    })
  });
};
var CheckboxFilterGroup = function CheckboxFilterGroup(_ref4) {
  var filterName = _ref4.filterName,
    subtitle = _ref4.subtitle,
    checkboxGroupElements = _ref4.checkboxGroupElements,
    onChange = _ref4.onChange,
    _ref4$actionButtons = _ref4.actionButtons,
    actionButtons = _ref4$actionButtons === void 0 ? [] : _ref4$actionButtons,
    _ref4$disabled = _ref4.disabled,
    disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
    _ref4$expandToFillCon = _ref4.expandToFillContainerHeight,
    expandToFillContainerHeight = _ref4$expandToFillCon === void 0 ? false : _ref4$expandToFillCon;
  var classes = useStyles({
    expandToFillContainerHeight: expandToFillContainerHeight
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classes.wrapper,
    children: [subtitle && /*#__PURE__*/_jsx(Typography, {
      style: {
        margin: "8px 0px"
      },
      color: RaiseColors.grayscale900,
      weight: "semibold",
      variant: "overline_small",
      children: subtitle
    }), /*#__PURE__*/_jsx(FormControl, {
      className: classes.formControl,
      variant: "standard",
      children: /*#__PURE__*/_jsx(CheckBoxGroup, {
        checkboxGroupElements: checkboxGroupElements,
        filterName: filterName,
        onChange: onChange,
        actionButtons: actionButtons,
        disabled: disabled
      })
    })]
  });
};
export default CheckboxFilterGroup;